export default __webpack_public_path__ + "f958fdb4f161cf0164032257303784b4.svg";